import React, { useCallback, useEffect } from 'react';
import ClaimDetails from '../../components/claimDetails/claimDetails';
import * as actions from '../../actions';
import claimApplicationProjections from '../../projections/claimApplication';
import { useAppSelector, useAppDispatch } from '../../hooks/hooks';
// @ts-ignore
import { Loader } from 'arag-ui-lib';
import { Formik, FormikProps } from 'formik';
import currencyProjections from '../../projections/currency';
import { useTranslation } from 'react-i18next';

type Props = {
    claimApplication: {
        id: string;
        policyType: {
            code: string;
        };
        claimCategory: {
            code: string;
        };
        formType: {
            code: string;
        };
        answers: {
            [key: string]: any;
        };
    };
};

const ClaimDetailsContainer = (props: Props) => {
    const { claimApplication } = props;
    const dispatch = useAppDispatch();
    const currencyOptions: actions.CurrencySchema[] | null = useAppSelector(
        currencyProjections.currencies,
    );
    const questionsWithAnswersGroupedByStepExtended = useAppSelector(
        claimApplicationProjections.claimApplicationAnswersGroupedByStepExtended(
            claimApplication.id,
            currencyOptions,
        ),
    ) as {
        answers: { [key: string]: any };
        groupStepWithQuestions: any[];
        questionTypes: { [key: string]: any };
    };
    const loading = useAppSelector(
        claimApplicationProjections.loadingClaimDetailsData,
    );
    const { t } = useTranslation();
    const fetchQuestionsOfClaimTypeComboAction = useCallback(
        (payload: actions.fetchQuestionsOfClaimTypeComboAction) =>
            dispatch(actions.fetchQuestionsOfClaimTypeCombo(payload)),
        [dispatch],
    );

    const fetchQuestionGroupStepByPolicyTypeAndClaimCategoryAndClaimTypeByClaimApplicationAction =
        useCallback(
            (
                payload: actions.fetchQuestionGroupStepByPolicyTypeAndClaimCategoryAndClaimTypeByClaimApplicationAction,
            ) =>
                dispatch(
                    actions.fetchQuestionGroupStepByPolicyTypeAndClaimCategoryAndClaimTypeByClaimApplication(
                        payload,
                    ),
                ),
            [dispatch],
        );

    const fetchQuestionTypeAction = useCallback(
        (payload: actions.fetchQuestionTypesAction) =>
            dispatch(actions.fetchQuestionTypes(payload)),
        [dispatch],
    );
    useEffect(() => {
        fetchQuestionTypeAction({});
    }, []);

    useEffect(() => {
        if (claimApplication) {
            fetchQuestionGroupStepByPolicyTypeAndClaimCategoryAndClaimTypeByClaimApplicationAction(
                {
                    policyTypeCode:
                        claimApplication.policyType &&
                        claimApplication.policyType.code
                            ? claimApplication.policyType.code
                            : null,
                    claimCategoryCode:
                        claimApplication.claimCategory &&
                        claimApplication.claimCategory.code
                            ? claimApplication.claimCategory.code
                            : null,
                    formTypeCode:
                        claimApplication.formType &&
                        claimApplication.formType.code
                            ? claimApplication.formType.code
                            : null,
                    claimApplicationId: claimApplication.id,
                },
            );
            fetchQuestionsOfClaimTypeComboAction({
                policyTypeCode:
                    claimApplication.policyType &&
                    claimApplication.policyType.code
                        ? claimApplication.policyType.code
                        : null,
                claimCategoryCode:
                    claimApplication.claimCategory &&
                    claimApplication.claimCategory.code
                        ? claimApplication.claimCategory.code
                        : null,
                formTypeCode:
                    claimApplication.formType && claimApplication.formType.code
                        ? claimApplication.formType.code
                        : null,
                claimApplicationId: claimApplication.id,
            });
        }
    }, [claimApplication.id]);

    if (
        loading ||
        !claimApplication ||
        !questionsWithAnswersGroupedByStepExtended.answers ||
        (questionsWithAnswersGroupedByStepExtended?.answers &&
            Object.values(questionsWithAnswersGroupedByStepExtended.answers)
                .length === 0)
    ) {
        return <Loader variant={'inline'} label={`${t('loading')}`} />;
    }
    return (
        <Formik
            initialValues={questionsWithAnswersGroupedByStepExtended.answers}
            onSubmit={() => {}}
        >
            {(formikProps: FormikProps<any>) => {
                return (
                    <>
                        {questionsWithAnswersGroupedByStepExtended?.groupStepWithQuestions?.map(
                            (groupStepWithQuestions: any) => {
                                return (
                                    <ClaimDetails
                                        key={groupStepWithQuestions.code}
                                        groupStepWithQuestions={
                                            groupStepWithQuestions
                                        }
                                        questionTypes={
                                            questionsWithAnswersGroupedByStepExtended.questionTypes
                                        }
                                        formikProps={formikProps}
                                    />
                                );
                            },
                        )}
                    </>
                );
            }}
        </Formik>
    );
};

export default ClaimDetailsContainer;
